import Backbone from 'backbone';

import template from './currentSetting.pug';

export class CurrentSettingContextualAttributeView extends Backbone.View {
  initialize({
    i18n,
  }) {
    this.i18n = i18n;
  }

  render({
    showDeliveryStatusPopup,
  }) {
    const message = this.i18n.getString('Details_View_Current_Setting_Context_Attribute');
    this.$el.html(template({ message }));

    showDeliveryStatusPopup(this.el.outerHTML);
    return this;
  }
}
